// Unpublished Work © 2022 Deere & Company

import t from 'tcomb';
import {CustomerName} from '../customer/customer-name';
import {CommunicationLabels} from './communication-labels';

export const DbsLabels = t.struct({
    arNumber: t.String,
    dbsNumber: t.String,
    dbsType: t.String,
    customerType: t.String,
    customerName: CustomerName,
    communication: CommunicationLabels,
    entityId: t.String,
    inactiveReason: t.String,
    rewardsNumber: t.String
}, {
    defaultProps: {
        arNumber: '',
        dbsNumber: '',
        dbsType: '',
        customerType: '',
        customerName: new CustomerName({}),
        communication: new CommunicationLabels({}),
        entityId: '',
        inactiveReason: '',
        rewardsNumber: ''
    },
    name: 'DbsLabels'
});
